<template>
  <v-card class="com-pc-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title mr-2">{{ text.title }}</span>
      <v-tooltip right max-width="300" class="mr-2" nudge-bottom="120">
        <template v-slot:activator="{ on }">
          <v-icon color="white" light v-on="on">help_outline</v-icon>
        </template>
        <span>{{ text.hint }}</span>
      </v-tooltip>
    </v-row>
    <v-col class="com-pc-card-contents">
      <v-row v-if="isAttention" class="ma-0 pl-2">
        <span>
          浸水想定を表示できません。
          <br />地図を拡大してください。
        </span>
      </v-row>
      <v-row
        v-if="
          !isAttention &&
            (inundations.inundations == null ||
              Object.keys(this.$store.state.inundation.inundations).length == 0)
        "
        class="ma-0 pl-2"
      >
        <span>表示できる浸水想定が見つかりませんでした。</span>
      </v-row>
      <v-select
        v-if="
          !isAttention &&
            inundations.inundations != null &&
            Object.keys(this.$store.state.inundation.inundations).length != 0
        "
        v-model="selectedInundation"
        :items="inundations.inundations"
        label="河川を選択"
        item-text="inundationNm"
        item-value="inundationId"
        hide-details
        @change="changeInundation"
        return-object
      ></v-select>
      <v-row class="ma-0 pl-2">
        <span
          ><a
            class="link fld-inulist"
            :href="inuListUrl"
            @click="clickInuListLink"
            >{{ text.inuList }}</a
          ></span
        >
      </v-row>
    </v-col>
  </v-card>
</template>
<script>
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "iu-select",
  data() {
    return {
      selectedInundation: {},
      /** 文字列リソース */
      text: {
        title: "河川を選択",
        hint:
          "「提供している浸水想定区域図は、国土交通省の河川事務所が作成した想定最大規模（L2)の浸水想定区域図です。浸水想定区域図には、支川の決壊による氾濫、シミュレーションの前提となる降雨を超える規模の降雨による氾濫、高潮及び内水による氾濫等を考慮していませんので、この洪水浸水想定区域に指定されていない区域においても浸水が発生する場合や、想定される水深が実際の浸水深と異なる場合があります。」",
        inuList: "このサイトで提供している浸水想定区域図の一覧",
      },
    };
  },
  mounted() {
    if (!this.isAttention) {
      // 選択中浸水想定区域データがストアに設定済みであればプルダウンを更新
      if (
        this.$store.state.inundation.selectedInundationParam &&
        this.$store.state.inundation.selectedInundationParam.inundationId
      ) {
        this.selectedInundation = this.$store.state.inundation.selectedInundationParam;
      }
    }
    // 浸水想定区域未選択状態のみアクセスログ出力
    // 画面遷移時に選択状態であれば地図側でログ出力される
    if (
      this.isAttention ||
      this.inundations.inundations == null ||
      Object.keys(this.$store.state.inundation.inundations).length == 0
    ) {
      PageLog.log({
        page_log: "inundation",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        inun_cd: "-",
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    }
  },
  computed: {
    /**
     * 表示範囲の浸水想定区域データ
     */
    inundations: {
      get() {
        return {
          inundations: this.$store.state.inundation.inundations,
          selectedInundationParam: this.$store.state.inundation
            .selectedInundationParam,
        };
      },
    },
    /** 注意喚起表示 */
    isAttention: {
      get() {
        return (
          this.$store.state.map.zoom <
          this.$store.state.map.mapConfig.zoomInundation
        );
      },
    },
    /** 提供中の浸水想定一覧URL */
    inuListUrl: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls.inuListLink;
      },
    },
  },
  watch: {
    inundations(val) {
      this.selectedInundation = val.selectedInundationParam;
    },
  },
  methods: {
    changeInundation() {
      setTimeout(() => {
        this.$store.commit(
          "inundation/setSelectedInundationParam",
          this.selectedInundation
        );
      }, 100);
    },
    /** 詳細な浸水想定情報クリック */
    clickInuListLink() {
      // アクセスログ出力
      PageLog.log({
        page_log: "inun_Listlink",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fld-inulist {
  font-size: 0.9rem;
  text-decoration: none;
}
</style>
